import * as React from "react";
import {
    Link as ReactRouterLink,
    LinkProps as RouterLinkProps,
} from "react-router-dom";
import { Link as MuiLink } from "@mui/material";

/**
 * Use this component to link between pages in this application, as it uses the
 * react redux router to prevent roundtrips to the http server (which makes the
 * local state forget its state).
 * Use the `to` prop to define the browser url.
 *
 * @see `react-router-dom/Link`
 */
export const Link: React.FC<RouterLinkProps> = ({ children, ...rest }) => {
    return (
        <MuiLink component={ReactRouterLink} {...rest}>
            {children}
        </MuiLink>
    );
};
